const API_BASE = process.env.REACT_APP_API_URL || 'https://bplabo.jp';

export async function getScoreReview({ grade, categoryStats, wrongTaps, totalTimeSec }) {
  // The written review is generated by Gemini and costs money per round, so the
  // server requires a login. The result screen already falls back to a fixed
  // encouraging line when this call fails, so a signed-out player still gets a
  // complete result — grade, time, badges and category bars all come from the
  // device and never touch the server.
  const token = localStorage.getItem('bplabo_jwt_token');
  const response = await fetch(`${API_BASE}/api/tango/score-review`, {
    method: 'POST',
    headers: token
      ? { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
      : { 'Content-Type': 'application/json' },
    body: JSON.stringify({ grade, categoryStats, wrongTaps, totalTimeSec }),
  });

  if (!response.ok) throw new Error(`Server error: ${response.status}`);
  const data = await response.json();
  return data.comment;
}
